import * as React from "react"

const buildList = (listItems) => {
  return listItems.map((listItem) => {
    return <li key={listItem}>{listItem}</li>
  })
}

export default buildList;